import {
    IDatiqDateRange,
    IDatiqNumberRange
} from '@dat/datiq-core/models';

export enum DatiqGraphAxisType {
    Dollar = 'Dollar',
    Date = 'Date',
    Number = 'Number',
    Category = 'Category',
}

// these are lowercase so that they can be mapped to the AMCharts datafields, e.g. dateX, categoryY, etc.
export enum DatiqGraphAxisDataFieldNames {
    Date = 'date',
    Category = 'category',
    Value = 'value',
}

export enum DatiqGraphAxisDateTypes {
    Monthly = 'Monthly',
    Daily = 'Daily',
    Weekly = 'Weekly',
    Yearly = 'Yearly',
    BiYearly = 'BiYearly',
    MonthlyNoYear = 'MonthlyNoYear',
    Unknown = '',
}
export enum DatiqGraphTooltipTypes {
    Single = 'Single',
    Multiple = 'Multiple',
    Table = 'Table',
    MultipleMultiples = 'MultipleMultiples',
}
export enum DatiqGraphAxisValueTypes {
    Dollar = 'Dollar',
    Number = 'Number',
    Category = 'Category',
    Unknown = '',
}

export enum DatiqGraphAxisNumberTypes {
    Currency = 'Currency',
    CurrencyDollar = 'CurrencyDollar',
    Number = 'Number',
    Percent = 'Percent',
    Thousand = 'Thousand',
    Millage = 'Millage',
    CurrencyThousand = 'CurrencyThousand',
    Unknown = '',
}

export enum DatiqGraphSeriesType {
    Bar = 'Bar',
    Line = 'Line',
    Candlestick = 'Candlestick',
    Scatter = 'Scatter',
}

export enum DatiqGraphType {
    XYChart = 'XYChart',
    MapChart = 'MapChart',
}

export enum DatiqGraphSeriesPatternTypes {
    Striped = 'Striped',
    Unknown = '',
}

export type DatiqGraphAxisName = 'x' | 'y' | 'yClose';

export type DatiqGraphRange = IDatiqDateRange | IDatiqNumberRange;

export type DatiqGraphPosition = number | Date;

export enum DatiqGraphXYTypes {
    Miniature = 'Miniature',
    Unknown = '',
}
